// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"628":"290821b7","2111":"c86d035f","2536":"290821b7","4931":"290821b7","7652":"290821b7","8531":"290821b7"}[chunkId] + ".chunk.css";
};